import classNames from "classnames";
import { useEffect, useState } from "react";
import {
  GROUPING_TYPES,
  TEAM_TYPES
} from "rivals/components/pages/Teams/types";
import Select from "rivals/components/shared/Form/Select";
import {
  SelectOption,
  SelectVariant
} from "rivals/components/shared/Form/Select/types";
import { selectConferences } from "rivals/redux/conference/selectors";
import { selectHighschoolGroups } from "rivals/redux/highschool/selectors";
import { useAppSelector } from "rivals/shared/utils/hooks";
import styles from "./TeamsGroupsSelect.module.scss";
import strings from "./strings";
import type { Props } from "./types";
import { getConferencesOptions, getHighschoolGroupsOptions } from "./utils";

const { label } = strings;

const TeamsGroupsSelect = ({
  loading,
  onChange,
  pageParams,
  philter
}: Props): JSX.Element | null => {
  const [options, setOptions] = useState<SelectOption<string>[]>([]);
  const conferences = useAppSelector(selectConferences);
  const highschoolGroups = useAppSelector(selectHighschoolGroups);

  useEffect(() => {
    const hasConferences = !!conferences?.length;
    const hasHighschools = !!highschoolGroups?.length;

    if (hasConferences && pageParams.type === TEAM_TYPES.COLLEGES) {
      setOptions(getConferencesOptions(conferences));
    }

    if (hasHighschools && pageParams.type === TEAM_TYPES.HIGH_SCHOOLS) {
      setOptions(getHighschoolGroupsOptions(highschoolGroups));
    }
  }, [conferences, highschoolGroups]);

  return (
    <Select<string>
      ariaLabel={label}
      className={classNames(styles.teamsDropdown, {
        [styles.hidden]:
          pageParams.groupingType === GROUPING_TYPES.ALPHABETICALLY ||
          !options.length
      })}
      data={`${philter}-teams-groups-dropdown`}
      disabled={loading}
      onChange={onChange}
      options={options}
      value={pageParams.group}
      variant={SelectVariant.BORDER_ROUND}
    />
  );
};

export default TeamsGroupsSelect;
